import { FaCreditCard } from "react-icons/fa";
import { StructureBuilder } from "sanity/structure";

export default (S: StructureBuilder) =>
  S.documentListItem()
    .schemaType(`royalOne`)
    .icon(FaCreditCard)
    .id(`royalOne`)
    .title(`RoyalOne`);
